import type { PageableRangeInput } from '@allocab/allocab-extranet-api-types';
import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetInvoiceOutput, ExtranetInvoicesListInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { toPageableRangeInput } from '../mappers';
import { extranetQueryKeys } from '../queryKeys';

// `search`, `sortBy`, `sortDir`, `status[]` ne sont pas (encore) supportés par
// /v1/invoices/ : on les conserve dans l'input front pour stabilité d'API
// et tri/filtre client, mais ils sont ignorés côté call API.
//
// Note : ExtranetInvoiceOutput inclut déjà `rides[]` inline — plus besoin d'un
// endpoint detail séparé (le drawer consomme la même donnée).
export const useExtranetInvoicesList = (input: ExtranetInvoicesListInput) =>
  useQuery<ListOutput<ExtranetInvoiceOutput>>({
    queryKey: extranetQueryKeys.invoices.list(input),
    queryFn: () =>
      getExtranetApi().get<PageableRangeInput, ListOutput<ExtranetInvoiceOutput>>(
        '/v1/invoices/',
        toPageableRangeInput(input, {
          offset: input.page && input.limit ? (input.page - 1) * input.limit : undefined,
          limit: input.limit,
        }),
      ),
    enabled: Boolean(input.dateRange?.from && input.dateRange?.to),
    placeholderData: keepPreviousData,
  });
